import IPixelMapDay from "@interfaces/pixel-map-day.interface";

const calendarEasterEgg2023: IPixelMapDay = {
	status: 'awful',
	title: "Twenty Twenty-Three: Faux Wholesome Year",
	icon: "wine_bar",
	reason: `
		2023 was opened up by the following line from my friend:

		> Happy holidays Dart! Onto a more fruitful struggle for a healthy and strong year ahead of us!

		And boy, was that prediction **wrong**.

		2023 turned out to be the weirdest and zaniest year of my life, ever. I had broken a major milestone in my life this year, and I honestly regretted it for a good chunk of the year. Even though I learned to live with it and accept it as part of my history, I'll have to carry this mark moving forward.

		This year also marked the collapse of my failing friendships from **2021**. I had left the IMC Discord server and gave the ownership to some bully who *actively* turned my friends against me, and still smears my name to this day. I had decided to cut off my best friend of 5 years, Angela, through email. And quite a few people for this year came and stopped by, but didn't really last long. I also had distanced myself from the RC this year because they gossipped too much about me, and they didn't really deserve me opening up to them anymore after they told an old HS person my secrets. Also, that weird "love square"/"love pentagon" thing I was in 2022 had finally dissolved. Phew.

		In other news, there were a lot of newcomers in my life this year, the most notable of which was Kai! I had never had a more genuine online friend ever (except for Elaine), and she turned out to be super sweet. She was the only one who gave me a letter this year, which was absolutely adorable. I also strengthened my friendships with Max and Meryll, making them my primary "safety net" of friends, and the #1 group I'd run to whenever I wanted to confide in someone.

		I was in love this year, but only faintly. I had never confessed to the person whom I liked my actual feelings for them, it was only implied. But that didn't stop me from finding new, true love and trying dating apps. One of which hilariously ended just 4 days after I had decided to cut them off.

		I wasn't "in love" this year.

		Going through it, I thought I hated 2023. That it was a bad year. By keeping a mood calendar and a journal, I was able to realize that my year wasn't that bad. I had fun memories, and I'm glad I kept note of it all.
	`,
	spotify: {
		song: "Sour Grapes",
		artist: "LE SSERAFIM",
		link: "https://open.spotify.com/track/6wBpO4Xc4YgShnENGSFA1M?si=935545a899834f75",
		album: "FEARLESS"
	},
	resonatedLyrics: [
		"I just feel afraid",
		"I'll never bite, I'll never bite the pain",
	]
};

export default calendarEasterEgg2023;
